import { NavLink, useNavigate } from 'react-router-dom';
import { FC } from 'react';
import { Icon, Icons } from 'components/Icon';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { logout } from 'thunks/account-thunk';
import { selectAccountDetails } from 'selectors/account-selector';
import { AccountTypeEnum } from 'apps/user/types/user.enum.type';

interface IProps {
  close: () => void;
  isRoot?: boolean;
}

const Dropdown: FC<IProps> = ({ close, isRoot = false }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { user } = useAppSelector(selectAccountDetails);

  const isAdmin = user.accountType === AccountTypeEnum.ADMIN;

  const renderNavLink = (
    path: string,
    icon: Icons,
    name: string
  ): JSX.Element => (
    <NavLink
      onClick={close}
      className={({ isActive }) =>
        `py-2 pl-8 flex items-center w-fits normal text-[#353535] space-x-3 ${
          isActive ? 'bg-none' : ''
        }`
      }
      to={`${isRoot ? `${isAdmin ? 'admin' : `dashboard/${path}`}` : path}`}
    >
      <Icon name={icon} width={18} height={18} />
      <span className="text-xs font-medium text-[#353535]">{name}</span>
    </NavLink>
  );

  const handleLogout = () => {
    dispatch(logout());
    navigate('/', { replace: true });
  };

  return (
    <div
      className="absolute z-50 mt-2 w-full rounded-xl rounded-br-lg bg-white py-4 shadow"
      style={{ zIndex: 99999999999 }}
    >
      <div className="flex flex-col">
        {renderNavLink('', Icons.DashboardHamburger, 'Dashboard')}
        {!isAdmin && renderNavLink('profile', Icons.Profile, 'Profile')}
        <button
          className="flex items-center space-x-3 py-2 pl-8"
          type="button"
          onClick={handleLogout}
        >
          <Icon name={Icons.Logout} width={18} height={18} />
          <span className="text-xs font-medium">Logout</span>
        </button>
      </div>
    </div>
  );
};

export default Dropdown;
